(function () {
  "use strict";

  var QUESTION_COUNT = 4;
  var sensitivityLabels = {
    extremely: "Extremely sensitive",
    very: "Very sensitive",
    somewhat: "Somewhat sensitive",
    not: "Not sensitive"
  };
  var activityLabels = {
    very: "Very active outdoors",
    somewhat: "In + out most days",
    hardly: "Mostly indoors"
  };
  var pigmentationLabels = {
    melasma: "Melasma priority",
    spots: "Dark spot priority",
    unsure: "Uneven tone concern",
    none: "No visible spots"
  };

  function initSurvey(root) {
    if (!root || root.dataset.jqsInitialized === "true") return;
    root.dataset.jqsInitialized = "true";

    var dataNode = root.querySelector("[data-jqs-products]");
    var productData;

    try {
      productData = JSON.parse(dataNode.textContent);
    } catch (error) {
      productData = { currency: "USD", items: {} };
    }

    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-jqs-step]"));
    var result = root.querySelector("[data-jqs-result]");
    var counter = root.querySelector("[data-jqs-counter]");
    var instruction = root.querySelector("[data-jqs-instruction]");
    var progress = root.querySelector("[data-jqs-progress]");
    var progressBar = progress.parentElement;
    var checkoutButton = root.querySelector("[data-jqs-checkout]");
    var selectionSummary = root.querySelector("[data-jqs-selection-summary]");
    var cartStatus = root.querySelector("[data-jqs-cart-status]");

    var state = {
      step: 0,
      complete: false,
      answers: { routine: [] },
      selected: {},
      adding: false
    };

    function moveToSurveyTop() {
      window.requestAnimationFrame(function () {
        var surveyTop = root.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: Math.max(0, surveyTop - 8), behavior: "auto" });
      });
    }

    function focusHeading(container) {
      var heading = container && container.querySelector("h1");
      if (!heading) return;
      heading.setAttribute("tabindex", "-1");
      window.requestAnimationFrame(function () {
        try {
          heading.focus({ preventScroll: true });
        } catch (error) {
          heading.focus();
        }
      });
    }

    function updatePanelOptions(panel) {
      var questionId = panel.dataset.questionId;
      var answer = state.answers[questionId];
      var isMultiple = panel.hasAttribute("data-multiple");
      var buttons = panel.querySelectorAll("[data-jqs-option]");

      buttons.forEach(function (button) {
        var selected = isMultiple
          ? Array.isArray(answer) && answer.indexOf(button.dataset.value) !== -1
          : answer === button.dataset.value;
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
        button.querySelector(".jqs-option-check").textContent = selected ? "✓" : isMultiple ? "+" : "→";
      });

      var continueButton = panel.querySelector("[data-jqs-continue]");
      if (continueButton) {
        continueButton.disabled = !Array.isArray(answer) || answer.length === 0;
      }
    }

    function showStep(nextStep, shouldMove) {
      state.complete = false;
      state.step = Math.max(0, Math.min(QUESTION_COUNT - 1, nextStep));
      root.classList.remove("is-complete");
      result.hidden = true;

      panels.forEach(function (panel, index) {
        panel.hidden = index !== state.step;
        if (index === state.step) updatePanelOptions(panel);
      });

      var activePanel = panels[state.step];
      var percent = ((state.step + 1) / QUESTION_COUNT) * 100;
      counter.textContent = "QUESTION " + (state.step + 1) + " OF " + QUESTION_COUNT;
      instruction.textContent = activePanel.hasAttribute("data-multiple") ? "SELECT ALL" : "TAP ONE";
      progress.style.width = percent + "%";
      progressBar.setAttribute("aria-valuenow", String(percent));

      if (shouldMove !== false) moveToSurveyTop();
      focusHeading(activePanel);
    }

    function hasValue(list, value) {
      return Array.isArray(list) && list.indexOf(value) !== -1;
    }

    function setText(selector, value) {
      var node = root.querySelector(selector);
      if (node) node.textContent = value;
    }

    function renderChips(chips) {
      var list = root.querySelector("[data-jqs-answer-chips]");
      list.textContent = "";
      chips.filter(Boolean).forEach(function (chip) {
        var item = document.createElement("li");
        item.textContent = chip;
        list.appendChild(item);
      });
    }

    function buildPersonalization() {
      var routine = Array.isArray(state.answers.routine) ? state.answers.routine : [];
      var sensitivity = state.answers.sensitivity || "";
      var activity = state.answers.activity || "";
      var pigmentation = state.answers.pigmentation || "";
      var usesMakeup = hasValue(routine, "makeup");
      var usesPrescription = hasValue(routine, "prescription");
      var hasSensitivePriority = ["extremely", "very", "somewhat"].indexOf(sensitivity) !== -1;
      var hasPigmentationPriority = ["melasma", "spots", "unsure"].indexOf(pigmentation) !== -1;
      var pigmentationConcern = pigmentation === "melasma"
        ? "melasma"
        : pigmentation === "spots"
          ? "visible sun or dark spots"
          : "uneven tone or discoloration";
      var simplifiableSteps = routine.filter(function (item) {
        return item !== "none" && item !== "prescription";
      }).length;
      var routineSummary = simplifiableSteps === 0
        ? "SPF IS YOUR MAIN COSMETIC STEP"
        : simplifiableSteps + " OTHER " + (simplifiableSteps === 1 ? "STEP" : "STEPS") + " + SPF";

      var lotionFit = hasPigmentationPriority
        ? "You selected " + pigmentationConcern + " as a priority, so this is your everyday base: high SPF plus an antioxidant blend aimed at dark spots and uneven tone."
        : hasSensitivePriority
          ? "You said sensitivity matters, so this is your everyday base: a weightless formula JACKET recommends for sensitive skin and says won’t clog pores or cause breakouts."
          : usesMakeup
            ? "You wear makeup, so this works as your invisible everyday base without adding a greasy layer or white cast underneath it."
            : activity !== "hardly"
              ? "You spend time outside, so this is your everyday base: face + body coverage with 80-minute water/sweat resistance."
              : "You want a simple daily base, so this combines face + body SPF, hydration and antioxidant skincare in one step.";

      var sprayFit = activity === "very"
        ? "You’re outside most of the day, so this is your easiest full-coverage format for active days and body application."
        : activity === "somewhat"
          ? "You move in and out throughout the day, so keep this for quick coverage on active days without a heavy or oily finish."
          : "You’re mostly indoors, so think of this as your fast option for walks, weekends and the outdoor days that break your normal routine.";

      var powderFit = usesMakeup && hasPigmentationPriority
        ? "You wear makeup and selected " + pigmentationConcern + " as a priority, so this gives you a portable mineral SPF touch-up without restarting your routine."
        : usesMakeup
          ? "You wear makeup, so the built-in brush lets you add mineral SPF and cut shine without starting your routine over."
          : hasPigmentationPriority
            ? "You selected " + pigmentationConcern + " as a priority. This is your compact, matte touch-up option when you want mineral SPF during the day."
            : "You don’t regularly wear makeup, but this can still be your compact, matte SPF touch-up when lotion or spray feels less convenient.";

      var tintedFit = usesMakeup && hasPigmentationPriority
        ? "You wear makeup and selected " + pigmentationConcern + " as a priority, so this can replace a complexion step while helping even the look of tone."
        : usesMakeup
          ? "You wear makeup, so this combines your skin-evening tint, moisturizer and mineral SPF in one streamlined step."
          : hasPigmentationPriority
            ? "You selected " + pigmentationConcern + " as a priority, so the tint can help even the look of tone without requiring a separate complexion product."
            : hasSensitivePriority
              ? "You said sensitivity matters, so this is your tinted mineral option—JACKET recommends it for sensitive skin and says it won’t clog pores or cause breakouts."
              : "You keep your routine simple, so use this when you want hydration, mineral SPF and light complexion coverage in one step.";

      setText("[data-jqs-fit='lotion']", lotionFit);
      setText("[data-jqs-fit='spray']", sprayFit);
      setText("[data-jqs-fit='powder']", powderFit);
      setText("[data-jqs-fit='tinted']", tintedFit);
      setText("[data-jqs-moment='spray']", activity === "hardly" ? "OUTDOOR DAYS" : "ACTIVE DAYS");
      setText("[data-jqs-moment='powder']", usesMakeup ? "OVER MAKEUP" : "MATTE TOUCH-UP");
      setText("[data-jqs-moment='tinted']", usesMakeup ? "TINT + SPF" : "3-IN-1 STEP");
      setText("[data-jqs-routine-summary]", routineSummary);
      setText("[data-jqs-activity-summary]", activityLabels[activity] || "");
      setText("[data-jqs-pigmentation-summary]", pigmentationLabels[pigmentation] || "");

      renderChips([
        sensitivityLabels[sensitivity],
        activityLabels[activity],
        usesMakeup ? "Wears makeup" : hasValue(routine, "none") ? "SPF-first routine" : routineSummary,
        pigmentationLabels[pigmentation]
      ]);

      setText(
        "[data-jqs-disclaimer]",
        (usesPrescription
          ? "Keep prescription care separate and check product compatibility with your clinician. "
          : "This guide personalizes format and routine fit; it is not a diagnosis. ") +
          "Sunscreen still needs regular reapplication as directed."
      );
    }

    function selectedKeys() {
      return Object.keys(state.selected).filter(function (key) {
        return state.selected[key] && productData.items[key] && productData.items[key].available;
      });
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
          style: "currency",
          currency: productData.currency || "USD",
          minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (error) {
        return "$" + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
      }
    }

    function renderProductSelection() {
      root.querySelectorAll("[data-jqs-product]").forEach(function (button) {
        var key = button.dataset.jqsProduct;
        var selected = Boolean(state.selected[key]);
        var card = button.closest("[data-jqs-product-card]");
        var name = card.querySelector("h2").textContent.trim();

        card.classList.toggle("is-selected", selected);
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-pressed", selected ? "true" : "false");

        if (!button.disabled) {
          button.querySelector("span").textContent = selected ? "ADDED" : "ADD";
          button.querySelector("b").textContent = selected ? "✓" : "+";
          button.setAttribute("aria-label", (selected ? "Remove " : "Add ") + name + (selected ? " from" : " to") + " your routine");
        }
      });

      var keys = selectedKeys();
      var total = keys.reduce(function (sum, key) {
        return sum + Number(productData.items[key].price || 0);
      }, 0);

      if (keys.length === 0) {
        selectionSummary.textContent = "Choose any that fit";
        checkoutButton.textContent = "SELECT A PRODUCT";
        checkoutButton.disabled = true;
      } else {
        selectionSummary.textContent = keys.length + " " + (keys.length === 1 ? "item" : "items") + " • " + money(total);
        checkoutButton.textContent = "CONTINUE TO CART →";
        checkoutButton.disabled = state.adding;
        checkoutButton.setAttribute(
          "aria-label",
          "Continue to JACKET cart with " + keys.length + " selected " + (keys.length === 1 ? "item" : "items")
        );
      }
    }

    function showResults() {
      state.complete = true;
      root.classList.add("is-complete");
      panels.forEach(function (panel) { panel.hidden = true; });
      result.hidden = false;
      counter.textContent = "YOUR JACKET GUIDE";
      instruction.textContent = "COMPLETE";
      progress.style.width = "100%";
      progressBar.setAttribute("aria-valuenow", "100");
      buildPersonalization();
      renderProductSelection();
      moveToSurveyTop();
      focusHeading(result);
    }

    function chooseOption(button) {
      var panel = button.closest("[data-jqs-step]");
      var questionId = panel.dataset.questionId;
      var value = button.dataset.value;

      if (panel.hasAttribute("data-multiple")) {
        var previous = Array.isArray(state.answers[questionId]) ? state.answers[questionId] : [];
        if (value === "none") {
          state.answers[questionId] = previous.indexOf("none") !== -1 ? [] : ["none"];
        } else {
          var withoutNone = previous.filter(function (item) { return item !== "none"; });
          state.answers[questionId] = withoutNone.indexOf(value) !== -1
            ? withoutNone.filter(function (item) { return item !== value; })
            : withoutNone.concat(value);
        }
        updatePanelOptions(panel);
        return;
      }

      state.answers[questionId] = value;
      updatePanelOptions(panel);
      if (state.step === QUESTION_COUNT - 1) showResults();
      else showStep(state.step + 1);
    }

    function buildCartDestination() {
      var destination = new URL(root.dataset.cartUrl || "/cart", window.location.origin);
      var current = new URLSearchParams(window.location.search);
      var allowed = [
        "utm_id", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content",
        "gclid", "dclid", "fbclid", "msclkid", "ttclid", "srsltid"
      ];
      allowed.forEach(function (name) {
        if (current.has(name)) destination.searchParams.set(name, current.get(name));
      });
      return destination.pathname + destination.search;
    }

    function addSelectionToCart() {
      var keys = selectedKeys();
      if (state.adding || keys.length === 0) return;

      var items = keys.map(function (key) {
        return { id: Number(productData.items[key].variantId), quantity: 1 };
      });
      var total = keys.reduce(function (sum, key) {
        return sum + Number(productData.items[key].price || 0);
      }, 0);
      var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

      state.adding = true;
      cartStatus.textContent = "";
      checkoutButton.disabled = true;
      checkoutButton.textContent = "ADDING…";

      fetch(routeRoot.replace(/\/?$/, "/") + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (response.ok) return response.json();
          return response.json().catch(function () { return {}; }).then(function (error) {
            throw new Error(error.description || error.message || "Unable to add these products right now.");
          });
        })
        .then(function () {
          if (window.oaiq) {
            window.oaiq("measure", "items_added", {
              type: "contents",
              amount: total,
              currency: productData.currency || "USD",
              contents: keys.map(function (key) {
                return {
                  id: Number(productData.items[key].variantId),
                  quantity: 1,
                  amount: Number(productData.items[key].price || 0)
                };
              })
            });
          }
          window.location.assign(buildCartDestination());
        })
        .catch(function (error) {
          state.adding = false;
          cartStatus.textContent = error.message || "Couldn’t add those items. Please try again.";
          renderProductSelection();
        });
    }

    root.addEventListener("click", function (event) {
      var option = event.target.closest("[data-jqs-option]");
      if (option && root.contains(option)) {
        chooseOption(option);
        return;
      }

      var back = event.target.closest("[data-jqs-back]");
      if (back && !back.disabled) {
        showStep(state.step - 1);
        return;
      }

      if (event.target.closest("[data-jqs-continue]")) {
        showStep(state.step + 1);
        return;
      }

      if (event.target.closest("[data-jqs-review]")) {
        showStep(QUESTION_COUNT - 1);
        return;
      }

      var productButton = event.target.closest("[data-jqs-product]");
      if (productButton && !productButton.disabled) {
        var key = productButton.dataset.jqsProduct;
        state.selected[key] = !state.selected[key];
        cartStatus.textContent = "";
        renderProductSelection();
        return;
      }

      if (event.target.closest("[data-jqs-checkout]")) addSelectionToCart();
    });

    showStep(0, false);
  }

  function initAll(container) {
    var scope = container || document;
    if (scope.matches && scope.matches("[data-jqs-root]")) initSurvey(scope);
    scope.querySelectorAll("[data-jqs-root]").forEach(initSurvey);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
